const getEnvVariable = (host: string) => {
    const envsMap: { [host: string]: string } = {
        'www.telia.lt': 'prod',
        'www-preprod.telia.lt': 'preprod',
        'www-qas.telia.lt': 'qas',
        'www-qas3.telia.lt': 'qas3',
        'www-qas4.telia.lt': 'qas4',
        'www-dev.telia.lt': 'dev',
        'release-qas.telia.lt': 'rqas',
        'localhost:9000': 'local',
        'localhost:3000': 'local',
        'localhost:3001': 'local',
    };

    return envsMap[host] || 'qas';
};

export const getMaintenanceBannerCookieName = (cookieName: string) => {
    const env = getEnvVariable(window.location.host);

    return `${cookieName}-${env}`;
};

export const getCookieMainDomain = () => {
    const host = window.location.host;

    return host.substring(host.lastIndexOf('.', host.lastIndexOf('.') - 1)).replace(/:\d+/, '');
};
